module.exports = __webpack_public_path__ + "static/media/supplier-icon2.ba6ab39f.svg";